import { useFreeWard } from "hooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const WardSelect = ({
  districtId,
  orderType,
  wardDefault,
  districtDefault,
  ...props
}) => {
  const { t } = useTranslation(["order"]);
  const { data: wards, refetch: refetchWards } = useFreeWard({
    countryId: 1,
    order_type: orderType,
    parent_code: districtId,
  });
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (districtId) {
      refetchWards();
    }
  }, [districtId]);

  useEffect(() => {
    let _options =
      wardDefault && districtId === districtDefault?.code
        ? [
            {
              label: wardDefault.name,
              value: wardDefault.code,
            },
          ]
        : [];
    for (const key in wards) {
      _options.push({
        label: wards[key],
        value: key,
      });
    }
    setOptions(_options);
  }, [wards, wardDefault, districtId, districtDefault]);

  if (props.value && !props.value.label) {
    props.value.label = options.find(e => e.value == props.value.value)?.label;
  }

  return (
    <Select
      {...props}
      placeholder={t("placeholder.select", {
        title: t("form.receiver_ward_code"),
      })}
      options={options}
      classNamePrefix="select2-selection"
    />
  );
};
export default WardSelect;
